import { Options } from '../Options'

export const availabilityOptions = Options.asRecord(
  Options.createOption({
    key: 'disabled',
    inputKind: 'boolean',
    label: 'Disabled',
    description:
      'Disable this feature or value. Omitted and false are both active.',
    category: 'Availability',
  }),
  Options.createOption({
    key: 'displayDisabled',
    inputKind: 'boolean',
    label: 'Display disabled',
    description: 'Omit this value when rendering an object as text.',
    category: 'Availability',
  }),
)
